import { GET, PUT } from '../../apiController';

const endpoint = '/admin/settings/notification';

export const getAdminNotificationSettings = () => {
  return GET(endpoint);
};

export const updateAdminNotificationSettings = (data) => {
  return PUT(endpoint, data);
};

export const updateMasterNotificationSettings = (notificationsEnabled) => {
  return PUT(`${endpoint}/master`, {
    notifications_enabled: notificationsEnabled,
  });
};
